module.exports = __webpack_public_path__ + "img/pr-5_.dacb27eb.png";